import { useAlert as useAlertHook } from "components/Alerts/hooks"
import { alerts } from "keys"
import { useCallback } from "react"

const useAlert = () => {
    const { setAlerts } = useAlertHook()

    const handleCreateClassAlert = useCallback((value) => {
        setAlerts(alerts.createClass, value)
    }, [])

    return handleCreateClassAlert
}

export default useAlert